export enum OrganizationStructureEnum {
  Association = "association",
  Company = "company",
}

const values = Object.values(OrganizationStructureEnum);

export default values;
